import {RoleType} from './role-type';

export enum Checker2 {
  PROJECT_MANAGER = RoleType.PROJECT_MANAGER,
  PROJECT_DEPUTY_MANAGER = RoleType.PROJECT_DEPUTY_MANAGER,
}
